module.exports = __webpack_public_path__ + "img/award-3.e9dd6770.png";